import { render } from "./ClauseComparison.vue?vue&type=template&id=46b08cb7&scoped=true"
import script from "./ClauseComparison.vue?vue&type=script&lang=js"
export * from "./ClauseComparison.vue?vue&type=script&lang=js"

import "./ClauseComparison.vue?vue&type=style&index=0&id=46b08cb7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b08cb7"]])

export default __exports__